import React, { useEffect, useState } from "react";
import Section from "../components/Section";
import Container from "@material-ui/core/Container";
import { Box, Typography } from "@material-ui/core";
import {CircularProgress} from "@material-ui/core";
import { blogUrl } from "../util/blogFeaturesSettings";

const BlogPages = (props) => {
  const [Fetched_Blog, setFetchedBlog] = useState();
  const [loading,setLoading]=useState()

  useEffect(() => {
    setLoading(true)
    const fetchDataById = async (slugTitle) => {
      const storedBlogMetaData = localStorage.getItem("blogMetaData");

      if (storedBlogMetaData) {
        // Parse the JSON data
        const parsedBlogMetaData = JSON.parse(storedBlogMetaData);

        const findIdBySlugTitle = (slugTitle) => {
          const foundData = parsedBlogMetaData.find(
            (data) => data.slugTitle === slugTitle
          );
          return foundData ? foundData.id : null;
        };

        // Check if id is available
        const id = findIdBySlugTitle(slugTitle);

        if (id) {
          try {
            // Make the API request
            const response = await fetch(
              `${blogUrl}/api/tasks/${id}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            // Check if the request was successful (status code 200-299)
            if (!response.ok) {
              throw new Error(
                `Error: ${response.status} - ${response.statusText}`
              );
            }

            // Parse the JSON response
            const data = await response.json();

            // Log or use the data as needed
            // console.log('Fetched Blog:', data);

            // Set the fetched data in state
            setFetchedBlog(data);
          } catch (error) {
            console.error("Error fetching data:", error.message);
          } finally {setLoading(false)}
        }
      }
    };

    // Fetch data when the component mounts
    if (props.slugTitle) {
      fetchDataById(props.slugTitle);
    }
  }, [props.slugTitle]);

  if(loading){
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
        <CircularProgress />
      </div>
    );
  }
  return (
    <Section>
      {Fetched_Blog && (
        <Container>
          {/* Title For Blog Page  */}
          <Typography
          gutterBottom
            variant="h4"
            style={{
              fontFamily: " Chakra Petch, sans-serif",
              fontSize: "30px",
            }}
          >
            {Fetched_Blog.title}
          </Typography>
          <Typography
          gutterBottom
          variant="subtitle1"
            style={{
              fontFamily: " Chakra Petch, sans-serif",
              fontSize: "20px",
            }}
          >
            {Fetched_Blog.description}
          </Typography>
          <Box>
            <img
              alt="coverImage"
              src={
                Fetched_Blog.coverImage
              }
              style={{
                width: "100%",
                minWidth: "100%",
                objectFit: "contain",
                borderRadius: "20px",
              }}
            />
          </Box>

          {/* Index section */}
          <Box
            style={{
              padding: "1rem",
              border: "1px solid grey",
              borderRadius: "1.5rem",
            }}
          >
            <ul style={{ listStyle: "none" }}>
              <Typography
                style={{
                  fontFamily: "Chakra Petch, sans-serif",
                  fontSize: "20px",
                }}
              >
                Table Of Content
              </Typography>

              {Fetched_Blog.sections.map(
                (section) =>
                  section.id  && (
                    <li key={section.id}>
                      <Typography
                    
                        style={{
                          fontFamily: "Chakra Petch, sans-serif",
                          fontSize: "20px",
                        }}
                      >
                        -{section.subheading}
                      </Typography>
                    </li>
                  )
              )}
            </ul>
          </Box>
          {/* content */}

          {Fetched_Blog.sections.map(
            (section, index) =>
              section && (
                <Box
                  key={section.id}
                  marginY={"10px"}
                  borderBottom={"1px solid silver"}
                >
                  <Typography
                    style={{

                      fontFamily: " Chakra Petch, sans-serif",
                      fontSize: "30px",
                    }}
                  >
                    
                    {section.subheading}
                  </Typography>
                  {section.contentSections.map((content, contentIndex) => (
                    <Box key={content.id}>
                      {content.type === "text" ? (
                        <Typography
                          style={{
                            fontFamily: "Chakra Petch, sans-serif",
                            fontSize: "20px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html:
                              content.content &&
                              typeof content.content === "string"
                                ? content.content.replace(/\n/g, "<br>")
                                : "",
                          }}
                        />
                      ) : (
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <img
                            alt={`section-${index}-content-${contentIndex}`}
                            src={content.content}
                            style={{
                              width: "100%",
                              minWidth: "100%",
                              maxHeight: "500px",
                              objectFit: "contain",
                              borderRadius: "20px",
                            }}
                          />
                        </Box>
                      )}
                    </Box>
                  ))}
                </Box>
              )
          )}

          <Box></Box>
        </Container>
      )}
    </Section>
  );
};

export default BlogPages;
